import { createFileRoute } from '@tanstack/react-router';

import { redirectIfAuthenticated } from '@/app/guards';
import { LandingPage } from '@/features/auth';

/** Portal landing: sign-in for visitors, straight to the organisation home for a live session. */
export const Route = createFileRoute('/')({
  beforeLoad: redirectIfAuthenticated,
  component: LandingPage,
});
